var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53094 0.5H19.4041C20.8318 0.5 22 1.71519 22 3.13292V13.7995C22 15.2847 20.8319 16.5 19.4041 16.5H2.53094C1.16812 16.5 0 15.2848 0 13.7995V3.13292C0 1.71519 1.16812 0.5 2.53094 0.5ZM13.9526 7.99358L9.40994 5.29308C9.02051 5.02309 8.56628 5.29308 8.56628 5.76561V11.2341C8.56628 11.6392 9.02051 11.9092 9.40994 11.7066L13.9526 9.00613C14.342 8.73614 14.342 8.19606 13.9526 7.99348V7.99358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.0a7f87a3.svg";
export { ForwardRef as ReactComponent };